import React from "react";
import { connect } from "react-redux";
import { Container, Button, Form } from "react-bootstrap";

import AppComponent from "../../../Components/AppComponent";
import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import NavBar from "../../Components/NavBar";
import api from "../../../Services/Api/api";

const SCREEN_NAME = "DASHBOARD_SCREEN";

class DashboardScreen extends AppComponent {
  async changePassword(e) {
    try {
      e.preventDefault();
      const { loading, password, newPassword, confirmPassword } = this.state;
      if (loading) return;

      if (newPassword !== confirmPassword)
        throw new Error("Your new passwords do not match");

      await this.setAsyncState({ loading: true, error: null });
      await api.put("v1/user/self/password", {
        password: newPassword,
        oldPassword: password,
      });
      await this.setAsyncState({ loading: false, password: '', newPassword: '', confirmPassword: '' });
      window.alert("Your password has been changed successfully");

    } catch (e) {
      await this.setAsyncState({ loading: false, error: e.message });
    }
  }

  render() {
    const {
      state: { loading, error, password, newPassword, confirmPassword },
    } = this;

    const content = (
      <div className="profile">
        {loading ? <div>Loading..</div> : null}
        {error ? <div className="errormsg">{error}</div> : null}

        <center>
          <Form
            style={{ maxWidth: "250px", textAlign: "left" }}
            onSubmit={this.changePassword.bind(this)}
          >
            <Form.Group className="mb-4" controlId="formBasicPassword1">
              <Form.Label>Current Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-1" controlId="formBasicPassword1">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                value={newPassword}
                onChange={(e) => this.setState({ newPassword: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="formBasicPassword1">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e) =>
                  this.setState({ confirmPassword: e.target.value })
                }
              />
            </Form.Group>

            <div className="errormsg">{error}</div>

            <Button
              variant="primary"
              type="submit"
              disabled={!password || loading || newPassword !== confirmPassword}
            >
              {loading ? "Loading" : "Submit"}
            </Button>
          </Form>
        </center>
      </div>
    );

    return (
      <>
        <NavBar activeLink="/user" />
        <Container className="gainner">{content}</Container>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.pState.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardScreen);
